import { useQuery } from '@tanstack/react-query';

import { get } from '../../../lib/api';

// The audience as rows for RecipientFieldDialog's table and Review's
// "Preview as" list: who will receive this broadcast, with their employee ID
// so an admin can key values off a spreadsheet they already have. Only
// fetched once the broadcast targets an audience (recipient fields have no
// meaning otherwise).
export const useFetchRecipientRows = ({ id, enabled = true }) => {
  const { data } = useQuery(
    ['broadcastRecipientRows', id],
    () => get(`/api/client_admin/broadcast_messages/${id}/recipient_rows`),
    {
      refetchOnWindowFocus: false,
      enabled: !!id && enabled,
      initialData: { rows: [], total: 0 },
    },
  );

  const { rows, total } = data;

  return {
    recipientRows: rows,
    recipientRowsTotal: total,
  };
};
